import { Grid } from '@mui/material';

import { FormRichTextField } from '../../../../../common';
import { DISCHARGE_CRITERIA_FIELDS } from '../constants';

import type { DischargeCriteriaFieldsProps } from './types';

export default function DischargeCriteriaFields({
  formik,
  disabled,
  readOnly,
  saveField,
}: DischargeCriteriaFieldsProps) {
  return (
    <Grid container columnSpacing={1.25} rowSpacing={2}>
      {DISCHARGE_CRITERIA_FIELDS.map((field) => (
        <Grid item key={field.name} xs={12} md={6}>
          <FormRichTextField
            disabled={disabled}
            formik={formik}
            label={field.label}
            name={field.name}
            onBlur={saveField}
            placeholder={field.placeholder}
            readOnly={readOnly}
            required
          />
        </Grid>
      ))}
    </Grid>
  );
}
